import "./App.css";
import AppRouter from "./router/AppRouter";
import { ToastsProvider } from "./contexts/toasts";
import { AuthProvider } from "./contexts/auth";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return <AppRouter />;
}

export default function withContext() {
  return (
    <HelmetProvider>
      <ToastsProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastsProvider>
    </HelmetProvider>
  );
}
